module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4>'+
((__t=( i18n.tc("UserNotInstaller", "You do not have installer privileges") ))==null?'':__t)+
'</h4><p>'+
((__t=( i18n.tc("UserNotInstaller", "If you believe this to be a mistake, try logging in again or contact your employer.") ))==null?'':__t)+
'</p><fieldset class="button-wrap"><button class="primary" data-click="no-installer-close">'+
((__t=( i18n.tc("UserNotInstaller", "Close") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
